//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import $ from 'jquery';
import axios from 'axios';

export default {
    data: function data() {
        return {
            errorMessage: '',
            placeHolderMessage: '',
            geoCountryCode: '',
            type: 'all',
            searchText: '',
            loading: false,
            domain: '',
            cannotFindProfile: false
        };
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    created: function created() {
        if (process.client) {
            this.domain = document.location.hostname.replace('www.', '').replace('.com', '');
        }
    },

    methods: {
        setCannotFindProfile: function setCannotFindProfile() {
            $("#url").val('');
            this.cannotFindProfile = true;
        },
        removeFromListing: function removeFromListing() {
            var _this = this;

            if (this.validateFormInput()) {
                var person_id = '';
                var url_ar = $("#url").val() ? $("#url").val().split("/") : '';
                if (!this.cannotFindProfile && url_ar.length > 1 && url_ar[url_ar.length - 1]) {
                    person_id = url_ar[url_ar.length - 1];
                }

                var form = {};
                form['person_id'] = person_id;
                form['name'] = $("#name").val();
                form['country'] = $("#country").val();
                form['city'] = $("#city").val();
                form['state'] = $("#state").val();
                form['by_url'] = !this.cannotFindProfile;

                this.loading = true;
                axios.post(global.websiteSettings.extra_info.api_endpoint + 'api/common/' + this.lang + '/remove-from-lisiting', form).then(function (res) {
                    _this.loading = false;
                    if (flash) flash(_this.$root.trans('st_public.Your profile removed from the listing successfully'), 'success');
                    _this.$router.push({ name: 'lang' });
                }).catch(function (err) {
                    _this.loading = false;
                    if (err.response.data.errors && err.response.data.errors.name) {
                        _this.errorMessage = err.response.data.errors.name[0];
                    } else if (err.response.data.errors && err.response.data.errors.person_id) {
                        _this.errorMessage = err.response.data.errors.person_id[0];
                    } else {
                        _this.errorMessage = err.response.data.message;
                    }
                });
            }
        },
        validateFormInput: function validateFormInput() {
            var result = true;
            this.errorMessage = '';

            if (this.cannotFindProfile && $('#name').val().trim() == '' || !this.cannotFindProfile && $('#url').val().trim() == '') {
                result = false;
                this.errorMessage = this.$root.trans('st_public.Please enter URl or Your Fullname to process your request');
            }
            return result;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/optout.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/optout.vue
// module chunks = 35